import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions } from '@/shared';
import { useGetIva } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveIVA } from '../../shared/components';

export interface UpdateIvaPageInterface {}

const UpdateIvaPage: React.FC<UpdateIvaPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_iva);

  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetIva(id!);

  if (isLoading || isRefetching) return <LoaderComponent />;
  if (!data?.data?.id_iva) return <Navigate to={ROUTER_PATHS.administration.ivaNav} />;

  return <SaveIVA titlePage="Editar IVA" editIVA={data.data} />;
};

export default UpdateIvaPage;
